import type { Asset } from '../entities/asset';
import { AssetType } from '../entities/asset-type';

import { data } from './data/assets';

export function getMockedAssets(
  siteId: string,
  _: Date,
  type: AssetType,
): Asset[] {
  const assets = data[siteId];

  return assets.filter((asset) =>
    mockedAssetTypesFromAssetTypes[type].includes(asset.type),
  );
}

const mockedAssetTypesFromAssetTypes: Record<AssetType, AssetType[]> = {
  [AssetType.PCS]: [AssetType.PCS],
  [AssetType.CONTAINER]: [AssetType.CONTAINER, AssetType.PCS],
  [AssetType.STRING]: [AssetType.STRING],
  [AssetType.RACK]: [AssetType.RACK],
  [AssetType.MODULE]: [AssetType.MODULE],
};
